import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {
  DiMongodb,
  DiPython,
  DiJavascript1,
} from "react-icons/di";
import {
  SiDocker,
  SiKubernetes,
  SiTypescript,
  SiNvidia,
  SiPytorch,
  SiTensorflow,
  SiGooglecloud,
  SiMysql,
  SiPostgresql,
  SiSwift
} from "react-icons/si";

const TECH_STACK = [
  { id: "python", label: "Python", icon: <DiPython /> },
  { id: "cpp", label: "C++", icon: <CgCPlusPlus /> },
  { id: "javascript", label: "JavaScript", icon: <DiJavascript1 /> },
  { id: "typescript", label: "TypeScript", icon: <SiTypescript /> },
  { id: "cuda", label: "CUDA", icon: <SiNvidia /> },
  { id: "pytorch", label: "PyTorch", icon: <SiPytorch /> },
  { id: "tensorflow", label: "TensorFlow", icon: <SiTensorflow /> },
  { id: "sql", label: "SQL", icon: <SiMysql /> },
  { id: "mongodb", label: "MongoDB", icon: <DiMongodb /> },
  { id: "postgres", label: "PostgreSQL", icon: <SiPostgresql /> },
  { id: "docker", label: "Docker", icon: <SiDocker /> },
  { id: "kubernetes", label: "Kubernetes", icon: <SiKubernetes /> },
  { id: "gcp", label: "Google Cloud", icon: <SiGooglecloud /> },
  { id: "swift", label: "Swift", icon: <SiSwift /> },
];

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {TECH_STACK.map((tech) => (
        <Col
          xs={4}
          md={2}
          className="tech-icons"
          key={tech.id}
          title={tech.label}
          aria-label={tech.label}
          data-label={tech.label}
        >
          {tech.icon}
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
